import { ProfileVerification } from '../../types/types';

interface PropTypes {
  data?: ProfileVerification[];
}

export default function VerificationBadge({ data }: PropTypes) {
  return (
    <span className="inline-flex items-center">
      {data?.map((verification, index) => (
        <span
          key={verification.id}
          className={`inline-flex h-auto w-auto ${
            data.length - 1 === index ? '' : 'mr-0.5'
          }`}
        >
          <img
            src={verification.badge_url}
            alt=""
            aria-hidden="true"
            style={{
              width: 15,
              height: 15
            }}
          />
        </span>
      ))}
    </span>
  );
}
